/**
 * ft-collapse.js — make the EasySearch YMM fitment table collapsible (Factory 47).
 * The app renders a long "N vehicles are compatible" table that makes PDPs very
 * tall. This keeps the app's header + count visible and collapses the table body
 * behind an accessible toggle (collapsed by default). Additive, flag-gated; the
 * app itself is untouched. Waits for the app's async render via a MutationObserver.
 */
(function () {
  'use strict';

  function enhance(widget) {
    if (widget.__f47ftDone) return;
    var holder = widget.querySelector('.easysearch-ft-holder');
    var header = holder && holder.querySelector('.easysearch-ft-header');
    var table = holder && holder.querySelector('.easysearch-ft-table-holder');
    if (!holder || !table || table.querySelectorAll('tr').length < 2) return; // wait until populated
    widget.__f47ftDone = true;

    var sub = widget.querySelector('.easysearch-ft-subtitle');
    var count = sub && (sub.textContent.match(/\d+/) || [])[0];
    var showLabel = count ? ('Show all ' + count + ' compatible vehicles') : 'Show all compatible vehicles';

    widget.classList.add('f47-ft-collapsible', 'f47-ft-collapsed');
    table.style.maxHeight = '0px';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'f47-ft-toggle';
    btn.setAttribute('aria-expanded', 'false');
    var txt = document.createElement('span'); txt.className = 'f47-ft-toggle__txt'; txt.textContent = showLabel;
    var ico = document.createElement('span'); ico.className = 'f47-ft-toggle__ico'; ico.setAttribute('aria-hidden', 'true'); ico.textContent = '▾';
    btn.appendChild(txt); btn.appendChild(ico);

    btn.addEventListener('click', function () {
      var collapsed = widget.classList.toggle('f47-ft-collapsed');
      btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      txt.textContent = collapsed ? showLabel : 'Hide compatible vehicles';
      table.style.maxHeight = collapsed ? '0px' : (table.scrollHeight + 'px');
    });

    if (header && header.parentNode) header.insertAdjacentElement('afterend', btn);
    else table.parentNode.insertBefore(btn, table);
  }

  function scan() {
    var widgets = document.querySelectorAll('.easysearch-ft-widget');
    for (var i = 0; i < widgets.length; i++) { try { enhance(widgets[i]); } catch (e) {} }
  }

  function init() {
    scan();
    if (window.MutationObserver) {
      var pending = null;
      var obs = new MutationObserver(function () { if (pending) clearTimeout(pending); pending = setTimeout(scan, 120); });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
